/*
* 2021-07-16
* lee
* 电销枚举类型
*
* */
//  电销员工执行的业务类型
export { ExecType as ExecType } from "@/pbjs/xcommon/enum_pb";
//  是否出勤
export { Bool as BoolPresentStatus } from "@/pbjs/xcommon/common_pb";
//  工作状态
export { UserWorkStatus as UserWorkStatus } from "@/pbjs/xcommon/common_pb";
//  审核结果
export { VerifyAction as VerifyActionStatus } from "@/pbjs/xcommon/ticket_pb";